/**
 * PageHeader — en-tête de page unifié (titre + actions).
 *
 * Source unique de la mise en page des en-têtes. Remplace les ~70 classes
 * d'en-tête maison (page-table-header, hr-page__header, cs-header, ca-header…).
 *
 * Props :
 *   title     : string | node          — titre H1 (obligatoire)
 *   subtitle  : string | node          — ligne fine sous le titre (optionnel)
 *   actions   : node                   — boutons/sélecteurs alignés à droite (optionnel)
 *   children  : node                   — rangée d'outils contextuels sous le titre (optionnel)
 *   timeless  : bool                   — page transverse sans dimension temporelle
 *                                        (Settings, utilitaires) : masque le cluster
 *                                        année/mois (ReportingControls).
 *   className : string                 — classes additionnelles sur le <header>
 */
import InfoTooltip from './InfoTooltip';
import './PageHeader.css';

export default function PageHeader({ title, subtitle, actions, children, className = '' }) {
  // Le contexte de reporting (exercice + frontière réel/prévision) a quitté
  // l'en-tête le 2026-08-18 : il vit dans la barre supérieure, à côté du
  // client. La prop `timeless` que passent encore des pages n'a plus d'effet.
  const titled = title != null && title !== '';
  return (
    <header className={`page-header${className ? ' ' + className : ''}`}>
      <div className="page-header__text">
        {titled && (
          <div className="page-header__title-row">
            {/* Flèches ‹ › retirées (décision 2026-08-16) : la navigation entre
                sections passe par le rail et ses flyouts — <ReportNav /> reste
                disponible dans reportNav.js si le mode revue revient. */}
            <h1 className="page-header__title" data-tour="page-title">{title}</h1>
            {/* Sous-titre replié derrière un ⓘ (décision 2026-08-16) : l'en-tête
                reste une seule ligne, l'explication s'ouvre à la demande. */}
            {subtitle != null && subtitle !== '' && (
              <InfoTooltip title={typeof title === 'string' ? title : undefined} body={subtitle} />
            )}
          </div>
        )}
        {children && <div className="page-header__tools">{children}</div>}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
      {/* Nœud d'accueil de la BANDE DE CONTEXTE (2026-09-18) : elle s'y pose
          par portail, à l'extrémité de la ligne du titre. Elle occupait sinon
          un étage de 56 px avant la première donnée, et le titre de la page
          tombait bien plus bas que celui du module dans le menu. */}
      <div className="page-header__ctx" id="lk-pagebar" />
    </header>
  );
}
